import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rental-point',
    templateUrl: './rental-point.component.html',
    styleUrls: ['./rental-point.component.scss'],
    standalone: false
})
export class RentalPointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
